/**
 * The remote office connector (ADR-0006): the consent page an assistant sends the human to, and the
 * Profile block that lists what they connected. Ukrainian base locale, like every other dictionary.
 */
export const connect = {
  // ---- consent page (/connect) ----
  'connect.title': 'Під’єднати помічника',
  'connect.asks': 'просить доступ до офісу від твого імені.',
  'connect.as': 'Ти увійшла як {name} ({email}). Помічник зможе робити те саме, що й ти в панелі — не більше.',
  'connect.scope.read': 'читати задачі, затвердження, прогони й агентів;',
  'connect.scope.write': 'створювати задачі, коментувати, змінювати статус, вирішувати затвердження;',
  'connect.scope.limits': 'у межах твоїх прав; кожна дія потрапляє в аудит як твоя.',
  'connect.revoke': 'Доступ можна відкликати будь-коли у Профілі.',
  'connect.allow': 'Дозволити',
  'connect.deny': 'Відмовити',
  'connect.invalid': 'Запит на під’єднання неповний або застарілий. Почни з помічника ще раз.',

  // ---- Profile block ----
  'profile.assistants': 'Під’єднані помічники',
  'profile.assistants.intro': 'Застосунки, які працюють в офісі від твого імені через конектор.',
  'profile.assistants.none': 'Поки нічого не під’єднано.',
  'profile.assistants.howto': 'Додай офіс як конектор у claude.ai або Claude Code за адресою {url} — далі він сам приведе тебе сюди.',
  'profile.assistants.connected': 'під’єднано {date}',
  'profile.assistants.lastUsed': 'останнє звернення {date}',
  'profile.assistants.revoke': 'Відкликати',
} as const;
